import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useIsUnifiedSignInEnabled = () => Boolean(useFlag(LaunchDarklyFlag.UNIFIED_SIGN_IN));
